import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgFormControlErrorsComponent} from './ng-form-control-errors.component';
import {NgFormControlErrorsContent} from './ng-form-control-errors-content';
import {NgFormControlErrorsInvalid} from './ng-form-control-errors-invalid';
export class NgFormControlErrorsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule
    ],
    declarations: [
        NgFormControlErrorsComponent,
        NgFormControlErrorsContent,
        NgFormControlErrorsInvalid,
    ],
    exports: [
        NgFormControlErrorsComponent,
        NgFormControlErrorsContent,
        NgFormControlErrorsInvalid
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgFormControlErrorsModule_tsickle_Closure_declarations() {
/** @type {?} */
NgFormControlErrorsModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgFormControlErrorsModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
